// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "rescript/lib/es6/belt_Result.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as GraphqlTag from "graphql-tag";
import * as Graphql_ppx_runtime from "@reasonml-community/graphql-ppx/rescript-runtime/graphql_ppx_runtime.res.mjs";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as QueryHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/QueryHook2.res.mjs";
import * as DateUtils$LiteracyplanetClientSxEntry from "./DateUtils.res.mjs";
import * as UserContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/UserContext.res.mjs";
import * as FlagsContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/FlagsContext.res.mjs";
import * as Storyverse$LiteracyplanetClientSxEntry from "./Storyverse.res.mjs";
import * as AvatarFragments$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/AvatarFragments.res.mjs";
import * as CobraAvatarType$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/CobraAvatarType.res.mjs";
import * as JourneyCurrentStudent$LiteracyplanetClientSxEntry from "./JourneyCurrentStudent.res.mjs";
import * as RequestMissionsMutation$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/RequestMissionsMutation.res.mjs";
import * as JourneyMissionsSubscription$LiteracyplanetClientSxEntry from "./JourneyMissionsSubscription.res.mjs";

var Raw = {};

var query = GraphqlTag.gql([
      "fragment FriendsAvatarFragment on FriendsAvatar   {\n__typename  \nuserId  \navatar  {\n...PlayerEquippedFragment   \n}\n\n}\n",
      ""
    ], AvatarFragments$LiteracyplanetClientFlags.PlayerEquippedFragment.query);

function parse(value) {
  var value$1 = value.avatar;
  return {
          __typename: value.__typename,
          userId: value.userId,
          avatar: !(value$1 == null) ? AvatarFragments$LiteracyplanetClientFlags.PlayerEquippedFragment.verifyArgsAndParse("PlayerEquippedFragment", value$1) : undefined
        };
}

function serialize(value) {
  var value$1 = value.avatar;
  var avatar = value$1 !== undefined ? AvatarFragments$LiteracyplanetClientFlags.PlayerEquippedFragment.serialize(value$1) : null;
  var value$2 = value.userId;
  var value$3 = value.__typename;
  return {
          __typename: value$3,
          userId: value$2,
          avatar: avatar
        };
}

function verifyArgsAndParse(_FriendsAvatarFragment, value) {
  return parse(value);
}

function verifyName(param) {
  
}

var FriendsAvatarFragment = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};

var Raw$1 = {};

var query$1 = GraphqlTag.gql(["fragment StudentTeacherFragment on StudentTeacher   {\n__typename  \nnextUserId  \ntitle  \nfamilyName  \n}\n"]);

function parse$1(value) {
  var value$1 = value.nextUserId;
  var value$2 = value.title;
  var value$3 = value.familyName;
  return {
          __typename: value.__typename,
          nextUserId: !(value$1 == null) ? value$1 : undefined,
          title: !(value$2 == null) ? value$2 : undefined,
          familyName: !(value$3 == null) ? value$3 : undefined
        };
}

function serialize$1(value) {
  var value$1 = value.familyName;
  var familyName = value$1 !== undefined ? value$1 : null;
  var value$2 = value.title;
  var title = value$2 !== undefined ? value$2 : null;
  var value$3 = value.nextUserId;
  var nextUserId = value$3 !== undefined ? value$3 : null;
  var value$4 = value.__typename;
  return {
          __typename: value$4,
          nextUserId: nextUserId,
          title: title,
          familyName: familyName
        };
}

function verifyArgsAndParse$1(_StudentTeacherFragment, value) {
  return parse$1(value);
}

function verifyName$1(param) {
  
}

var StudentTeacherFragment = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  verifyArgsAndParse: verifyArgsAndParse$1,
  verifyName: verifyName$1
};

var Raw$2 = {};

var query$2 = GraphqlTag.gql([
      "fragment EnrolleeFragment on Enrollee   {\n__typename  \nteachers  {\n...StudentTeacherFragment   \n}\n\nprofile  {\n__typename  \ncountry  {\n__typename  \ntwoLetterCode  \n}\n\n}\n\n}\n",
      ""
    ], query$1);

function parse$2(value) {
  var value$1 = value.teachers;
  var value$2 = value.profile;
  var tmp;
  if (value$2 == null) {
    tmp = undefined;
  } else {
    var value$3 = value$2.country;
    tmp = {
      __typename: value$2.__typename,
      country: !(value$3 == null) ? ({
            __typename: value$3.__typename,
            twoLetterCode: value$3.twoLetterCode
          }) : undefined
    };
  }
  return {
          __typename: value.__typename,
          teachers: value$1.map(parse$1),
          profile: tmp
        };
}

function serialize$2(value) {
  var value$1 = value.profile;
  var profile;
  if (value$1 !== undefined) {
    var value$2 = value$1.country;
    var country;
    if (value$2 !== undefined) {
      var value$3 = value$2.twoLetterCode;
      var value$4 = value$2.__typename;
      country = {
        __typename: value$4,
        twoLetterCode: value$3
      };
    } else {
      country = null;
    }
    var value$5 = value$1.__typename;
    profile = {
      __typename: value$5,
      country: country
    };
  } else {
    profile = null;
  }
  var value$6 = value.teachers;
  var teachers = value$6.map(serialize$1);
  var value$7 = value.__typename;
  return {
          __typename: value$7,
          teachers: teachers,
          profile: profile
        };
}

function verifyArgsAndParse$2(_EnrolleeFragment, value) {
  return parse$2(value);
}

function verifyName$2(param) {
  
}

var EnrolleeFragment = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  verifyArgsAndParse: verifyArgsAndParse$2,
  verifyName: verifyName$2
};

var Raw$3 = {};

var query$3 = GraphqlTag.gql([
      "query JourneyMissionsQuery($userId: String!, $avatarUserIds: [String!]!, $nextUuids: [ID!]!)  {\ncurrentStudent(userId: $userId)  {\n__typename  \n...JourneyCurrentStudentFragment   \nenrollee  {\n...EnrolleeFragment   \n}\n\nfriendsAvatars(userIds: $avatarUserIds)  {\n...FriendsAvatarFragment   \n}\n\nincompleteMissions: incompleteVisibleMissionsNonOptional  {\n...JourneyStudentMissionFragment   \n}\n\ncompletedMissions: pagedCompletedMissionsNonOptional(page: 1)  {\n...JourneyStudentMissionFragment   \n}\n\n}\n\npublicStudentProfiles(nextUuids: $nextUuids)  {\n__typename  \nnextUuid  \ncountry  {\n__typename  \ntwoLetterCode  \n}\n\nshortName  \n}\n\n}\n",
      "",
      "",
      "",
      ""
    ], JourneyCurrentStudent$LiteracyplanetClientSxEntry.JourneyCurrentStudentFragment.query, JourneyCurrentStudent$LiteracyplanetClientSxEntry.JourneyStudentMissionFragment.query, query, query$2);

function parse$3(value) {
  var value$1 = value.currentStudent;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1["enrollee"];
    var value$3 = value$1["friendsAvatars"];
    var value$4 = value$1["incompleteMissions"];
    var value$5 = value$1["completedMissions"];
    tmp = {
      __typename: value$1["__typename"],
      journeyCurrentStudentFragment: JourneyCurrentStudent$LiteracyplanetClientSxEntry.JourneyCurrentStudentFragment.verifyArgsAndParse("JourneyCurrentStudentFragment", value$1),
      enrollee: !(value$2 == null) ? parse$2(value$2) : undefined,
      friendsAvatars: value$3.map(parse),
      incompleteMissions: value$4.map(function (value) {
            return JourneyCurrentStudent$LiteracyplanetClientSxEntry.JourneyStudentMissionFragment.verifyArgsAndParse("JourneyStudentMissionFragment", value);
          }),
      completedMissions: value$5.map(function (value) {
            return JourneyCurrentStudent$LiteracyplanetClientSxEntry.JourneyStudentMissionFragment.verifyArgsAndParse("JourneyStudentMissionFragment", value);
          })
    };
  }
  var value$6 = value.publicStudentProfiles;
  return {
          currentStudent: tmp,
          publicStudentProfiles: value$6.map(function (value) {
                var value$1 = value.country;
                var value$2 = value.shortName;
                return {
                        __typename: value.__typename,
                        nextUuid: value.nextUuid,
                        country: !(value$1 == null) ? ({
                              __typename: value$1.__typename,
                              twoLetterCode: value$1.twoLetterCode
                            }) : undefined,
                        shortName: !(value$2 == null) ? value$2 : undefined
                      };
              })
        };
}

function serialize$3(value) {
  var value$1 = value.publicStudentProfiles;
  var publicStudentProfiles = value$1.map(function (value) {
        var value$1 = value.shortName;
        var shortName = value$1 !== undefined ? value$1 : null;
        var value$2 = value.country;
        var country;
        if (value$2 !== undefined) {
          var value$3 = value$2.twoLetterCode;
          var value$4 = value$2.__typename;
          country = {
            __typename: value$4,
            twoLetterCode: value$3
          };
        } else {
          country = null;
        }
        var value$5 = value.nextUuid;
        var value$6 = value.__typename;
        return {
                __typename: value$6,
                nextUuid: value$5,
                country: country,
                shortName: shortName
              };
      });
  var value$2 = value.currentStudent;
  var currentStudent;
  if (value$2 !== undefined) {
    var value$3 = value$2.completedMissions;
    var completedMissions = value$3.map(function (value) {
          return JourneyCurrentStudent$LiteracyplanetClientSxEntry.JourneyStudentMissionFragment.serialize(value);
        });
    var value$4 = value$2.incompleteMissions;
    var incompleteMissions = value$4.map(function (value) {
          return JourneyCurrentStudent$LiteracyplanetClientSxEntry.JourneyStudentMissionFragment.serialize(value);
        });
    var value$5 = value$2.friendsAvatars;
    var friendsAvatars = value$5.map(serialize);
    var value$6 = value$2.enrollee;
    var enrollee = value$6 !== undefined ? serialize$2(value$6) : null;
    var value$7 = value$2.__typename;
    currentStudent = [JourneyCurrentStudent$LiteracyplanetClientSxEntry.JourneyCurrentStudentFragment.serialize(value$2.journeyCurrentStudentFragment)].reduce(Graphql_ppx_runtime.deepMerge, {
          __typename: value$7,
          enrollee: enrollee,
          friendsAvatars: friendsAvatars,
          incompleteMissions: incompleteMissions,
          completedMissions: completedMissions
        });
  } else {
    currentStudent = null;
  }
  return {
          currentStudent: currentStudent,
          publicStudentProfiles: publicStudentProfiles
        };
}

function serializeVariables(inp) {
  var a = inp.avatarUserIds;
  var a$1 = inp.nextUuids;
  return {
          userId: inp.userId,
          avatarUserIds: a.map(function (b) {
                return b;
              }),
          nextUuids: a$1.map(function (b) {
                return b;
              })
        };
}

function makeVariables(userId, avatarUserIds, nextUuids, param) {
  return {
          userId: userId,
          avatarUserIds: avatarUserIds,
          nextUuids: nextUuids
        };
}

var GetMissions_inner = {
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query$3,
      Raw: Raw$3,
      parse: parse$3,
      serialize: serialize$3,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useFetch = include.useFetch;

var GetMissions = {
  GetMissions_inner: GetMissions_inner,
  Raw: Raw$3,
  query: query$3,
  parse: parse$3,
  serialize: serialize$3,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useFetch: useFetch
};

var defaultMissionTitle = "";

function makeDueDate(scalarDate) {
  return Caml_option.nullable_to_opt(DateUtils$LiteracyplanetClientSxEntry.graphqlScalarDateToDateTime(scalarDate).toRelative());
}

function makeTeacherName(enrollee, userId) {
  return Belt_Option.flatMap(Belt_Option.flatMap(Belt_Option.map(enrollee, (function (enrollee) {
                        return enrollee.teachers;
                      })), (function (teachers) {
                    return Belt_Array.getBy(teachers, (function (t) {
                                  return t.nextUserId === userId;
                                }));
                  })), (function (t) {
                var match = t.title;
                var match$1 = t.familyName;
                if (match !== undefined) {
                  if (match$1 !== undefined) {
                    return match + " " + match$1;
                  } else {
                    return ;
                  }
                } else if (match$1 !== undefined) {
                  return match$1;
                } else {
                  return ;
                }
              }));
}

function makeMission(hasAssigned, makeTeacherName, m) {
  return {
          missionId: String(m.id),
          missionTitle: Belt_Option.getWithDefault(m.title, defaultMissionTitle),
          strand: m.mission.strand,
          chestRarity: JourneyCurrentStudent$LiteracyplanetClientSxEntry.chestToString(m.chest),
          locked: hasAssigned ? Belt_Option.mapWithDefault(m.teacherAssignmentId, true, (function (param) {
                    return false;
                  })) : false,
          averageAccuracy: m.averageAccuracy,
          teacherAssigned: Belt_Option.isSome(m.teacherAssignmentId),
          teacherName: Curry._1(makeTeacherName, m.teacherAssignmentId),
          dueDate: Belt_Option.flatMap(m.expireAt, makeDueDate)
        };
}

function filter(prim0, prim1) {
  return prim0.filter(Curry.__1(prim1));
}

function pushLockedToFront(missions) {
  var locked = missions.filter(function (m) {
        return m.locked;
      });
  var unlocked = missions.filter(function (m) {
        return !m.locked;
      });
  return Belt_Array.concat(unlocked, locked);
}

function makeMissions(missions, makeTeacherName, hasAssigned) {
  return Belt_Array.map(missions, (function (param) {
                return makeMission(hasAssigned, makeTeacherName, param);
              }));
}

function makeOptionalExtraUser(avatar, userId, optProfile) {
  var profile = Belt_Option.mapWithDefault(optProfile, {
        country: "",
        shortName: ""
      }, (function (prof) {
          return {
                  country: Belt_Option.mapWithDefault(prof.country, "", (function (c) {
                          return c.twoLetterCode;
                        })),
                  shortName: Belt_Option.getWithDefault(prof.shortName, "")
                };
        }));
  return Belt_Option.map(avatar, (function (avatar) {
                return {
                        userId: userId,
                        avatar: CobraAvatarType$LiteracyplanetClientFlags.makeAvatar(avatar),
                        country: profile.country,
                        shortName: profile.shortName
                      };
              }));
}

function makeFriendsAvatars(avatars, profiles) {
  return Belt_Array.keepMap(Belt_Array.map(avatars, (function (friend) {
                    var optProfile = profiles.find(function (p) {
                          return p.nextUuid === friend.userId;
                        });
                    return makeOptionalExtraUser(friend.avatar, friend.userId, optProfile === undefined ? undefined : Caml_option.some(optProfile));
                  })), (function (i) {
                return i;
              }));
}

function hasAssigned(studentMissions) {
  return Belt_Array.some(studentMissions, (function (sm) {
                return Belt_Option.isSome(sm.teacherAssignmentId);
              }));
}

function makeProps(response, areProfilesFeatureEnabled) {
  return Belt_Option.map(response.currentStudent, (function (s) {
                var partial_arg = s.enrollee;
                var partial_arg$1 = s.enrollee;
                return {
                        areProfilesFeatureEnabled: areProfilesFeatureEnabled,
                        myCountryCode: Belt_Option.mapWithDefault(Belt_Option.flatMap(Belt_Option.flatMap(s.enrollee, (function (e) {
                                        return e.profile;
                                      })), (function (p) {
                                    return p.country;
                                  })), "", (function (c) {
                                return c.twoLetterCode;
                              })),
                        currentStudent: JourneyCurrentStudent$LiteracyplanetClientSxEntry.makeCurrentStudent(s.journeyCurrentStudentFragment),
                        extraUsers: makeFriendsAvatars(s.friendsAvatars, response.publicStudentProfiles),
                        completedMissions: makeMissions(s.completedMissions, (function (param) {
                                return makeTeacherName(partial_arg, param);
                              }), false),
                        incompleteMissions: pushLockedToFront(makeMissions(s.incompleteMissions, (function (param) {
                                    return makeTeacherName(partial_arg$1, param);
                                  }), hasAssigned(s.incompleteMissions))),
                        hasDiag: false,
                        progressData: undefined
                      };
              }));
}

function onLoading(param) {
  return "LoadingMissions";
}

function onResult(areProfilesFeatureEnabled, query) {
  return Belt_Result.flatMap(query, (function (response) {
                var props = makeProps(response, areProfilesFeatureEnabled);
                if (props !== undefined) {
                  return {
                          TAG: "Ok",
                          _0: {
                            TAG: "MissionProps",
                            _0: props
                          }
                        };
                } else {
                  return {
                          TAG: "Error",
                          _0: {
                            TAG: "ErrorWithMessage",
                            _0: "JourneyMissionsError",
                            _1: "error in makeProps"
                          }
                        };
                }
              }));
}

var Q = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw$3,
      use: use,
      useFetch: useFetch
    });

function useMissionQuery(userId, avatarUserIds, areProfilesFeatureEnabled) {
  return Curry._4(Q.useWithErrorModal, onLoading, onLoading, (function (param) {
                return onResult(areProfilesFeatureEnabled, param);
              }), {
              userId: userId,
              avatarUserIds: avatarUserIds,
              nextUuids: avatarUserIds
            });
}

function hasLocked(missions) {
  return Belt_Array.some(missions, (function (m) {
                return m.locked;
              }));
}

function appendMissions(previous, newest) {
  var newesetHasBeenAssigned = hasAssigned(newest);
  var wasLocked = Belt_Array.some(previous, (function (m) {
          return m.locked;
        }));
  var old = newesetHasBeenAssigned ? Belt_Array.map(previous, (function (m) {
            return {
                    missionId: m.missionId,
                    missionTitle: m.missionTitle,
                    strand: m.strand,
                    chestRarity: m.chestRarity,
                    locked: wasLocked ? m.locked : true,
                    averageAccuracy: m.averageAccuracy,
                    teacherAssigned: m.teacherAssigned,
                    teacherName: m.teacherName,
                    dueDate: m.dueDate
                  };
          })) : previous;
  return pushLockedToFront(Belt_Array.concat(old, Belt_Array.keepMap(makeMissions(newest, (function (param) {
                            
                          }), newesetHasBeenAssigned), (function (cur) {
                        if (Belt_Array.getBy(old, (function (old) {
                                  return old.missionId === cur.missionId;
                                })) === undefined) {
                          return Caml_option.some(cur);
                        }
                        
                      }))));
}

function mergeAsyncMissions(studentHasStoryverse, progressData, missionStates, subscription) {
  if (studentHasStoryverse) {
    if (progressData === undefined) {
      return "LoadingMissions";
    }
    if (typeof missionStates !== "object") {
      return "LoadingMissions";
    }
    var props = missionStates._0;
    if (subscription !== undefined) {
      return {
              TAG: "MissionProps",
              _0: {
                areProfilesFeatureEnabled: props.areProfilesFeatureEnabled,
                myCountryCode: props.myCountryCode,
                currentStudent: props.currentStudent,
                extraUsers: props.extraUsers,
                completedMissions: props.completedMissions,
                incompleteMissions: appendMissions(props.incompleteMissions, subscription),
                hasDiag: props.hasDiag,
                progressData: progressData
              }
            };
    } else {
      return {
              TAG: "MissionProps",
              _0: {
                areProfilesFeatureEnabled: props.areProfilesFeatureEnabled,
                myCountryCode: props.myCountryCode,
                currentStudent: props.currentStudent,
                extraUsers: props.extraUsers,
                completedMissions: props.completedMissions,
                incompleteMissions: props.incompleteMissions,
                hasDiag: props.hasDiag,
                progressData: progressData
              }
            };
    }
  }
  if (typeof missionStates !== "object") {
    return "LoadingMissions";
  }
  var props$1 = missionStates._0;
  if (subscription !== undefined) {
    return {
            TAG: "MissionProps",
            _0: {
              areProfilesFeatureEnabled: props$1.areProfilesFeatureEnabled,
              myCountryCode: props$1.myCountryCode,
              currentStudent: props$1.currentStudent,
              extraUsers: props$1.extraUsers,
              completedMissions: props$1.completedMissions,
              incompleteMissions: appendMissions(props$1.incompleteMissions, subscription),
              hasDiag: props$1.hasDiag,
              progressData: props$1.progressData
            }
          };
  } else {
    return {
            TAG: "MissionProps",
            _0: props$1
          };
  }
}

function useAsyncMissions(userId, avatarUserIds) {
  var progressData = Curry._1(Storyverse$LiteracyplanetClientSxEntry.use, userId);
  var hasFlag = FlagsContext$LiteracyplanetClientFlags.use();
  var studentHasStoryverse = Curry._1(hasFlag, "StudentHasStoryverse");
  var areProfilesFeatureEnabled = Curry._1(hasFlag, "FeatStudentProfile");
  var queriedMissionStates = useMissionQuery(userId, avatarUserIds, areProfilesFeatureEnabled);
  var tmp;
  tmp = typeof queriedMissionStates !== "object" ? true : queriedMissionStates._0.incompleteMissions.length !== 0;
  var subscription = JourneyMissionsSubscription$LiteracyplanetClientSxEntry.useSubscription(userId, tmp);
  return mergeAsyncMissions(studentHasStoryverse, progressData, queriedMissionStates, subscription);
}

function hasMissions(x) {
  if (typeof x !== "object") {
    return [
            true,
            false
          ];
  } else {
    return [
            false,
            x._0.incompleteMissions.length === 0
          ];
  }
}

function useCurrentUser(avatarUserIds) {
  var user = UserContext$LiteracyplanetClientFlags.use();
  var userId = user.userId;
  var startingPoint = user.startingPoint;
  var missionStates = useAsyncMissions(userId, avatarUserIds);
  var match = hasMissions(missionStates);
  RequestMissionsMutation$LiteracyplanetClientFlags.useRequestMissionsHook(userId, startingPoint, match[0], match[1]);
  return missionStates;
}

var JourneyCurrentStudentFragment;

var JourneyStudentMissionFragment;

var PlayerEquippedFragment;

export {
  JourneyCurrentStudentFragment ,
  JourneyStudentMissionFragment ,
  PlayerEquippedFragment ,
  FriendsAvatarFragment ,
  StudentTeacherFragment ,
  EnrolleeFragment ,
  GetMissions ,
  defaultMissionTitle ,
  makeDueDate ,
  makeTeacherName ,
  makeMission ,
  filter ,
  pushLockedToFront ,
  makeMissions ,
  makeOptionalExtraUser ,
  makeFriendsAvatars ,
  hasAssigned ,
  makeProps ,
  onLoading ,
  onResult ,
  Q ,
  useMissionQuery ,
  hasLocked ,
  appendMissions ,
  mergeAsyncMissions ,
  useAsyncMissions ,
  hasMissions ,
  useCurrentUser ,
}
/* query Not a pure module */
